import React, { Component } from 'react'

import AuthenticatedRoutes from './AuthenticatedRoutes'

class Authenticated extends Component {
  render() {
    return <AuthenticatedRoutes />
  }
}

export default Authenticated



// WEBPACK FOOTER //
// ./src/App/Authenticated.js